import React from 'react'
import SignUp from '../../templates/signUp'

function SignUpESPage () {
    return <SignUp lang="es" />
}
export default SignUpESPage
